import { render } from "./CreateUserTypeModal.vue?vue&type=template&id=25fcba70&scoped=true"
import script from "./CreateUserTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateUserTypeModal.vue?vue&type=script&lang=js"

import "./CreateUserTypeModal.vue?vue&type=style&index=0&id=25fcba70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fcba70"]])

export default __exports__